module.exports = __webpack_public_path__ + "img/kassa-3-topwise-t3.f26c3d4b.png";